import React from 'react';
import { ArrowDownIcon, HandshakeIcon } from 'lucide-react';
import { extras } from '../data/onboarding';
export function Hero() {
  return <header className="relative overflow-hidden border-b border-white/10 bg-[#0a0a0a] text-white" data-id="element-26" data-mp="eilfb8ex51em">
      <div className="hero-spotlight pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-27" data-mp="9l34tdl96e4i" />

      <div className="relative mx-auto w-full max-w-6xl px-5 pb-14 pt-9 sm:px-8 sm:pb-20 sm:pt-12" data-id="element-28" data-mp="4njqyesgw3d3">
        <div className="flex items-center gap-2.5" data-id="element-29" data-mp="128pi5dka8x4k">
          <span aria-hidden="true" className="flex h-8 w-8 items-center justify-center rounded-md border border-[#10b981]/40 bg-[#10b981]/10 font-mono text-sm font-bold text-[#10b981]" data-id="element-30" data-mp="x9usbrnwe8ay">
            V
          </span>
          <div className="leading-tight" data-id="element-31" data-mp="nbydaoruat7k">
            <p className="font-mono text-[13px] font-semibold tracking-tight text-white" data-id="element-32" data-mp="3d21sdxnwkknq">
              VIRIDIA ANALYTICS
            </p>
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#10b981]" data-id="element-33" data-mp="380vyhwiiarcm">
              Never Miss a Lead
            </p>
          </div>
        </div>

        <p className="mt-12 font-mono text-[11px] uppercase tracking-[0.28em] text-[#10b981] sm:mt-16" data-id="element-34" data-mp="3o7vj9hzbpjw8">
          Client Onboarding
        </p>

        <h1 className="mt-5 max-w-3xl font-mono text-[32px] font-bold leading-[1.08] tracking-tight text-white sm:text-[56px]" data-id="element-35" data-mp="39a32ynlycrgz">
          Welcome to Viridia.
          <span className="block text-white/60" data-id="element-36" data-mp="30hrjxmt646b1">Let&apos;s get you set up.</span>
        </h1>

        <div className="accent-rule mt-7 h-px w-40 sm:w-56" aria-hidden="true" data-id="element-37" data-mp="358zq89z7bbjz" />

        <p className="mt-7 max-w-xl text-[15.5px] leading-relaxed text-white/80 sm:text-lg" data-id="element-38" data-mp="2qk3m2o09mion">
          A short, calm walkthrough of your new AI phone receptionist and CRM — so every
          call, text and enquiry gets answered, and you never miss a lead again.
        </p>

        <div className="mt-8 flex max-w-xl gap-3 rounded-xl border border-[#10b981]/25 bg-[#10b981]/[0.08] px-4 py-4 sm:px-5" data-id="element-39" data-mp="2hlj8g19kaz7a">
          <HandshakeIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#10b981]" aria-hidden="true" data-id="element-40" data-mp="s2jnhxye22k1" />
          <p className="text-sm leading-relaxed text-white/85 sm:text-[15px]" data-id="element-41" data-mp="najhpovn0ffj">
            The AI-receptionist steps near the end (7 and 8) aren&apos;t DIY —{' '}
            <span className="font-semibold text-white" data-id="element-42" data-mp="ddf082cql852">we set those up with you</span>. Everything
            before them takes just a few minutes each.
          </p>
        </div>

        <ul className="mt-7 space-y-2.5" data-id="element-43" data-mp="161t2wverssmy">
          {extras.quickWins.map(item => {
          const Icon = item.icon;
          return <li key={item.label} className="flex items-center gap-2.5 text-sm text-white/70" data-id="element-44" data-mp="111ohcqz097pv">
                <Icon className="h-4 w-4 shrink-0 text-[#10b981]" aria-hidden="true" data-id="element-45" data-mp="x3h260k6wegs" />
                {item.label}
              </li>;
        })}
        </ul>

        <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-46" data-mp="3hpsff7k1zv33">
          <a href="#logging-in" className="inline-flex min-h-[52px] items-center justify-center gap-2 rounded-lg bg-[#10b981] px-6 text-[15px] font-semibold text-black transition-all duration-200 hover:bg-[#34d399]" data-id="element-47" data-mp="1xa41h7xz88gg">
            Start with step 1
            <ArrowDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-48" data-mp="2b0fxhhxomrcv" />
          </a>
          <a href="#need-a-hand" className="inline-flex min-h-[52px] items-center justify-center rounded-lg border border-[#10b981]/40 px-6 text-[15px] font-semibold text-[#10b981] transition-colors duration-200 hover:border-[#10b981] hover:bg-[#10b981]/10" data-id="element-49" data-mp="2b2kcaux4darx">
            Need a hand?
          </a>
        </div>
      </div>
    </header>;
}